export default __webpack_public_path__ + "static/media/menu-vip-logo-gold.4e628fd6.webp";